import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfirmationDialogService } from '../../confirmation-dialog/confirmation-dialog.service';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { DhukanDataService } from 'src/app/services/dhukan/dhukan-data.service';
import { LoginDataService } from 'src/app/services/dhukan/login-data.service';
import { ActivatedRoute } from '@angular/router';
@Component({
  selector: 'app-adddepartment',
  templateUrl: './adddepartment.component.html',
  styleUrls: ['./adddepartment.component.css']
})
export class AdddepartmentComponent implements OnInit {

  //Mode Values
  isaddmode: boolean = false;
  iseditmode: boolean = false;
  isdeletemode: boolean = false;
  isviewmode: boolean = false;

  //Save Validation
  submitted: boolean;
  successfully: boolean;
  saveloading: boolean;

  //Edit Get Values
  departmentColl: any = [];
  departmentid: number = 0

  countryColl: any = [];
  stateColl: any = [];
  //pageColl:any=[];

  departmentform = new FormGroup({
    departmentid: new FormControl(0),
    departmentname: new FormControl('', Validators.required),
    inactive: new FormControl(false),
  });

  isloading: boolean = false;
  isprivilage: boolean = false;
  showProgress: boolean = false;
  formname: String = "Department";


  @Input() departmentname: any = '';
  @Output() emitData = new EventEmitter();

  constructor(private toastr: ToastrService, private appService: DhukanDataService, private route: ActivatedRoute,
    private loginService: LoginDataService, private activeModal: NgbActiveModal, private confirmationDialogService: ConfirmationDialogService) {
    this.route.queryParams.subscribe(params => {
      if (params.id !== undefined) {
        this.departmentid = params.id
      }
    });
    this.fnServiceChanges();
  }

  fnServiceChanges() {
    this.loginService.serviceloginChange.subscribe((value) => {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {

        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnCompanyFaildRedirect();
      }         
      }
      else {
        this.fnUserFailedForm();
      }
    });
  }

  ngOnInit() {
    try {
      if (this.loginService.fnCheckCompany()) {
      if (this.loginService.fnCheckUser()) {
        if (this.fnCheckUserPririvilage()) {
          this.isloading = true;
          this.fnOnInitForm();
        }
        else {
          this.fnUserFailedForm();
        }
      }
      else {
        this.loginService.fnGetUserRoleList();
      }
    }
    else {
      this.loginService.fnCompanyFaildRedirect();
    }         
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }

  fnOnInitForm() {
    try {
      this.isaddmode = true;
      this.departmentform.reset();
      this.fnInitializeDepartment();

      if (this.departmentid > 0) {
        this.fngetDepartment();
      }
    
    } catch (ex) {
      this.fnShowErrorMsg(ex);
    }
  }



  fnCheckUserPririvilage() {
    var _check: boolean = false;
    if (this.departmentid > 0) {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'ALTER')
    } else {
      _check = this.loginService.fnCheckUserRoleAction(this.formname, 'CREATE')
    }

    return _check;
  }

  fnUserFailedForm() {
    this.isprivilage = true;
  }


  fnInitializeDepartment() {
    this.departmentform.setValue({

      departmentid: 0,
      departmentname: '',
      inactive:false,
    })
  }
 
  //Get 
  fngetDepartment() {
   
    var data = {
      'departmentid': this.departmentid,
      'companyid': this.loginService.fnGetCompanyId(),
    }
    this.appService.getDepartment(data)
      .subscribe(
        (res) => {
          this.departmentColl = res.json().result;
          var editdata = this.departmentColl[0];
          this.fnEditMode(editdata);
        },
        (err) => {
          this.toastr.error('Error', err);
        })
  }


  //Save Btn Click
  fnSaveBtnClick() {
 
    try {
      if(this.saveloading){
        return;
      }
      this.submitted = true;
      this.successfully = false;
      //Validate
      if (this.departmentform.valid) {
        this.saveloading=true
        //Check
        var data = {
          'departmentid': this.departmentid,
          'departmentname': this.departmentform.get('departmentname').value,
          'companyid': this.loginService.fnGetCompanyId(),
          'inactive': this.departmentform.get('inactive').value,
          'createdby': this.loginService.fnGetModUserId(),
          'modifiedby': this.loginService.fnGetModUserId(),
        }
      
        this.appService.fnCheckDepartment(data).subscribe(
          (res) => {
            //console.log(res)
            var _checkresult = res.json().result[0].checkfield;

            if (_checkresult === "done") {
              if (this.departmentform.get('departmentid').value > 0) {
                //Update Department
                this.fnSetDepartment(data);
              }
              else {
                //Insert Department
                this.fnInsertDepartment(data);
              }
            }
            else {
              if (_checkresult === "name") {
                this.saveloading=false
                this.departmentform.controls['departmentname'].setErrors({ 'notfound': true });
              }
            }
          },
          (err) => {
            this.saveloading=false
            this.toastr.error('Error', err);
          });
      }
    } catch (ex) {
      this.saveloading=false
      this.fnShowErrorMsg(ex);
    }
  }

  //Insert
  fnInsertDepartment(data) {

    this.appService.fnInsertDepartment(data).subscribe(
      (res) => {
        this.saveloading=false
        if (res.json().result != "") {
          this.toastr.success('', "The new Department has been added successfully.Insert Successfully");

          this.fnInsertActivityLog('INSERT', 0, data.departmentid);

          this.emitData.emit(this.departmentid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading=false
        this.toastr.error('Error', err);
      });

  }

  //Set
  fnSetDepartment(data) {

    this.appService.fnSetDepartment(data).subscribe(
      (res) => {
        this.saveloading=false
        if (res.json().result != "") {
          this.toastr.success('', "The Department has been updated successfully.");

          this.fnInsertActivityLog('EDIT', this.departmentid, data.departmentname);

          this.emitData.emit(this.departmentid);
          this.activeModal.close(true);
        }
      },
      (err) => {
        this.saveloading=false
        this.toastr.error('Error', err);
      });

  }



  private fnEditMode(deptBO) {

    this.departmentform.setValue({

      departmentid: deptBO.departmentid,
      departmentname: deptBO.departmentname,
      inactive: deptBO.inactive,
    });

    this.isaddmode = false;
    this.iseditmode = true;
    this.isdeletemode = false;
    this.isviewmode = false;
  }



  fnInsertActivityLog(action, refno, desc) {
    try {
      var data = {
        logtype: action,
        logat: this.formname,
        refnum: refno,
        logdescr: desc,
        logby: this.loginService.fnGetModUserId(),
        'companyid': this.loginService.fnGetCompanyId(),

      }


       this.appService.fnInsertActivity(data).subscribe(
         (res)=>{
         },
         (err)=>{

         });

    } catch {

    }
  }



  public decline() {
    this.activeModal.close(false);
  }



  private fnShowErrorMsg(ex) {
    this.toastr.warning('Internal Error', ex);
  }





}
